import React, {useEffect, useState} from 'react';
import {Row, Col, Box, Button} from 'adminlte-2-react';
import {ReferenciaObligatorios} from '../utils/etiquetaObligatorio/ReferenciaObligatorios';
import {Alert} from '../utils/Alert';
import {SelectInput} from '../utils/SelectInput';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {CheckBox} from '../ui/Checkbox';
import {MonedaInputV2} from '../ui/moneda';
import {CampoPublicacion} from './CampoPublicacion';
import Loader from '../utils/Loader';
import {ModalGenerico} from '../ui/ModalGenerico';
import {fuentesOptions} from '../utils/constants';
import {Content} from '../ui/Content';

const {TextInput} = require('../utils/TextInput');

function CrearOportunidadView({
  mode,
  history,
  match,
  modelCrearOportunidad,
  empresaOption,
  titulo,
  tituloPublicacion,
  cargoOption,
  rubroOption,
  rubroPublicacion,
  esConfidencial,
  publicarWeb,
  solicitudFecha,
  estadoOption,
  cierreEsperadoFecha,
  observacion,
  empresasOptions,
  setEmpresaOption,
  setTitulo,
  setTituloPublicacion,
  cargosOptions,
  setCargoOption,
  rubrosOptions,
  setRubroOption,
  setRubroPublicacion,
  setEsConfidencial,
  setSolicitudFecha,
  estadosOptions,
  setEstadoOption,
  setCierreEsperadoFecha,
  setObservacion,
  setPublicarWeb,
  etapas,
  handleSelection,
  salarioMinimo,
  setSalarioMinimo,
  salarioMaximo,
  setSalarioMaximo,
  pagoFormaOption,
  setPagoFormaOption,
  pagoFormaOptions,
  empleoTipoOption,
  setEmpleoTipoOption,
  empleoTipoOptions,
  submit,
  submitAlert,
  topAlert,
  aCargo,
  setACargo,
  usuarioOptions,
  usuarioSelected,
  setUsuarioSelected,
  rolSelected,
  setRolSelected,
  handleACargo,
  deleteACargo,
  ciudadSelected,
  setCiudadSelected,
  monedaSelected,
  setMonedaSelected,
  proposRef,
  responRef,
  conEspRef,
  conDesRef,
  expReqRef,
  aptitudesRef,
  reqAdRef,
  condContRef,
  muestraPosicion,
  setMuestraPosicion,
  muestraResponsabilidad,
  setMuestraResponsabilidad,
  muestraConocimientoEspecifico,
  setMuestraConocimientoEspecifico,
  muestraConocimientoDeseable,
  setMuestraConocimientoDeseable,
  muestraExperienciaRequerida,
  setMuestraExperienciaRequerida,
  muestraAptitud,
  setMuestraAptitud,
  muestraRequisitoAdicional,
  setMuestraRequisitoAdicional,
  muestraCondicionContratacion,
  setMuestraCondicionContratacion,
  ciudadesOptions,
  proposito,
  responsabilidad,
  conocimientoEspecifico,
  conocimientoDeseable,
  experienciaRequerida,
  aptitud,
  requisitoAdicional,
  condicionContratacion,
  loadOportunidadStatus,
  flyerSubmitAlert,
  flyer,
  oportunidadIdNumerico,
  eliminarFlyer,
  modalRedirect,
  setModalRedirect,
  isModalEliminarFlyerShown,
  setIsModalEliminarFlyerShown,
  oportunidadId,
  modelEliminarOportFlyer,
  modelGetOportFlyer,
  fuenteOption,
  setFuenteOption,
  isModalEliminarRelevamientoShown,
  setIsModalEliminarRelevamientoShown,
  modelEliminarOportRelevamiento,
  eliminarRelevamiento,
  modelGetOportRelevamiento,
  relevamientoSubmitAlert,
  relevamiento,
  creado,
  equipo,
  setEquipo,
  equipoOptions,
  setUsuariosPrioridad,
  usuariosPrioridad,
}) {
  const [usuarioOptionsPrioridad, setUsuarioOptionsPrioridad] = useState([]);

  useEffect(() => {
    if (aCargo) {
      const idsNumericos = Object.keys(aCargo);
      const usuariosOptions = usuarioOptions.filter(elem =>
        idsNumericos.includes(elem.value),
      );
      setUsuarioOptionsPrioridad(usuariosOptions);
    }
  }, [usuarioOptions, aCargo]);

  const rolOptions = [
    {
      value: 'selector',
      label: 'Selector',
    },
    {
      value: 'supervisor',
      label: 'Supervisor',
    },
    {
      value: 'soporte',
      label: 'Soporte',
    },    
  ];

  const aCargoKeys = Object.keys(aCargo);

  const title = mode === 'edit' ? 'Editar oportunidad' : 'Crear oportunidad';

  return (
    <Content title={title} history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {modalRedirect && (
        <ModalGenerico
          isModalShown={!!modalRedirect}
          hideModal={() => setModalRedirect(null)}
          title="Alerta"
          body="Si no guardaste los cambios hechos en el formulario, se perderán. ¿Continuar?"
          buttonText="Continuar"
          submit={() => {
            history.push(modalRedirect);
          }}
        />
      )}

      {oportunidadId && isModalEliminarFlyerShown && (
        <ModalGenerico
          isModalShown={isModalEliminarFlyerShown}
          hideModal={() => setIsModalEliminarFlyerShown(false)}
          title="Eliminar permanentemente"
          body={
            <>
              Se eliminará <b>permanentemente</b> el archivo y no se podrá
              recuperar. ¿Continuar?
            </>
          }
          buttonText="Eliminar"
          buttonType="danger"
          buttonDisabled={!oportunidadId}
          buttonLoading={modelEliminarOportFlyer.loading}
          submit={eliminarFlyer}
        />
      )}

      {oportunidadId && isModalEliminarRelevamientoShown && (
        <ModalGenerico
          isModalShown={isModalEliminarRelevamientoShown}
          hideModal={() => setIsModalEliminarRelevamientoShown(false)}
          title="Eliminar permanentemente"
          body={
            <>
              Se eliminará <b>permanentemente</b> el archivo y no se podrá
              recuperar. ¿Continuar?
            </>
          }
          buttonText="Eliminar"
          buttonType="danger"
          buttonDisabled={!oportunidadId}
          buttonLoading={modelEliminarOportRelevamiento.loading}
          submit={eliminarRelevamiento}
        />
      )}

      <Loader isLoading={mode === 'edit' && loadOportunidadStatus !== 'LOADED'}>
        <Row>
          <Col md="10" mdOffset="1">
            <Box title="Datos principales">
              <ReferenciaObligatorios />
              <Col md="4">
                <SelectInput
                  label="Empresa"
                  value={empresaOption}
                  options={empresasOptions}
                  setValue={setEmpresaOption}
                  required
                  disabled={mode === 'edit'}
                />
                <SelectInput
                  label="Cargo"
                  value={cargoOption}
                  options={cargosOptions}
                  setValue={setCargoOption}
                  required
                />
                <div style={{marginBottom: 10}}>
                  <label>
                    <Etiqueta texto={'Fecha de inicio'} obligatorio={true} />
                  </label>
                  <DatePicker
                    customInput={<input type="text" className="form-control" />}
                    selected={solicitudFecha}
                    onChange={date => setSolicitudFecha(date)}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </Col>
              <Col md="4">
                <TextInput
                  label="Título"
                  initialValue={titulo}
                  setValue={setTitulo}
                  required
                />
                <SelectInput
                  label="Rubro"
                  value={rubroOption}
                  options={rubrosOptions}
                  setValue={setRubroOption}
                  required
                />
                <SelectInput
                  label="Estado"
                  value={estadoOption}
                  options={estadosOptions}
                  setValue={setEstadoOption}
                  required
                />
              </Col>
              <Col md="4">
                <TextInput
                  label="Título a publicar"
                  initialValue={tituloPublicacion}
                  setValue={setTituloPublicacion}
                />
                <TextInput
                  label="Rubro a publicar"
                  initialValue={rubroPublicacion}
                  setValue={setRubroPublicacion}
                />
                <div className="form-group">
                  <CheckBox
                    checked={publicarWeb}
                    text={'Publicar en la web'}
                    onChange={setPublicarWeb}
                  />
                </div>

                {mode === 'edit' && (
                  <SelectInput
                    label="Fuente"
                    value={fuenteOption}
                    options={[
                      {value: null, label: 'Sin fuente'},
                      ...fuentesOptions,
                    ]}
                    setValue={setFuenteOption}
                  />
                )}
              </Col>

              {/* <div className="form-group">
                <CheckBox
                  checked={esConfidencial}
                  text={'Es confidencial'}
                  onChange={setEsConfidencial}
                />
              </div> */}

              <Col md="6">
                <div className="form-group">
                  <label>
                    <Etiqueta texto="Observación" obligatorio={false} />
                  </label>
                  <textarea
                    className="form-control"
                    rows="10"
                    value={observacion}
                    onChange={evt => setObservacion(evt.target.value)}
                  />
                </div>
              </Col>
              <Col md="6">
                <CampoPublicacion
                  titulo="Condiciones de contratación"
                  mRef={condContRef}
                  publicar={muestraCondicionContratacion}
                  setPublicar={setMuestraCondicionContratacion}
                  initialValue={condicionContratacion}
                  permiteCambiarValorPublicar={false}
                  required={true}
                />
              </Col>
            </Box>
          </Col>
        </Row>
        <Row>
          <Col md="10" mdOffset="1">
            <Col md="4">
              {mode === 'edit' && (
                <Box title="Búsqueda prioritaria">
                  <SelectInput
                    label="Usuario con búsqueda prioritaria"
                    value={usuariosPrioridad}
                    options={usuarioOptionsPrioridad}
                    setValue={setUsuariosPrioridad}
                    isMulti
                    required
                  />
                </Box>
              )}

              <Box title="Rango de salario">
                <MonedaInputV2
                  label="Salario mínimo"
                  initialValue={salarioMinimo}
                  setValue={setSalarioMinimo}
                  selectorMonedaDisabled={true}
                />
                <MonedaInputV2
                  label="Salario máximo"
                  initialValue={salarioMaximo}
                  setValue={setSalarioMaximo}
                  selectorMonedaDisabled={true}
                />
              </Box>

              <Box title="Información adicional">
                <SelectInput
                  label="Ciudad"
                  value={ciudadSelected}
                  options={ciudadesOptions}
                  setValue={setCiudadSelected}
                  required
                />
                <SelectInput
                  label="Forma de pago"
                  value={pagoFormaOption}
                  options={pagoFormaOptions}
                  setValue={setPagoFormaOption}
                  required
                />
                <SelectInput
                  label="Tipo de empleo"
                  value={empleoTipoOption}
                  options={empleoTipoOptions}
                  setValue={setEmpleoTipoOption}
                  required
                />
              </Box>
            </Col>

            <Col md="8">
              <Box title="Selectores y supervisores">
                <div
                  style={{
                    maxHeight: 460,
                    minHeight: 460,
                    overflowY: 'scroll',
                  }}>
                  <SelectInput
                    label="Equipo"
                    value={equipo}
                    options={equipoOptions}
                    setValue={setEquipo}
                    required
                  />
                  <SelectInput
                    label="Usuario"
                    value={usuarioSelected}
                    options={usuarioOptions}
                    setValue={setUsuarioSelected}
                    required
                  />
                  <SelectInput
                    label="Rol"
                    value={rolSelected}
                    options={rolOptions}
                    setValue={setRolSelected}
                    required
                  />
                  <Button
                    pullRight
                    type="default"
                    text="Agregar"
                    size="sm"
                    disabled={!usuarioSelected || !rolSelected}
                    onClick={() => handleACargo()}
                  />
                  {aCargoKeys.length > 0 && (
                    <>
                      <h4>Usuarios asignados</h4>
                      {aCargoKeys.map(key => {
                        return (
                          <>
                            <span>Nombre: {aCargo[key]?.name}</span>
                            <br />
                            <span>Rol: {aCargo[key]?.rolLabel}</span>
                            <br />
                            <div style={{marginTop: 10}}>
                              <Button
                                type="warning"
                                text="Eliminar"
                                size="sm"
                                onClick={() => deleteACargo(key)}
                              />
                            </div>
                            <br />
                          </>
                        );
                      })}
                    </>
                  )}
                </div>
              </Box>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col md="10" mdOffset="1">
            {mode === 'edit' && (
              <Col md="4">
                <Box
                  title="Flyer"
                  customOptions={
                    <ButtonWithLoading
                      text="Ir a agregar"
                      type="default"
                      size="sm"
                      loading={false}
                      submit={() =>
                        setModalRedirect(
                          `/oportunidad/flyer/${oportunidadIdNumerico}`,
                        )
                      }
                    />
                  }>
                  <div
                    style={{
                      maxHeight: 200,
                      minHeight: 200,
                      overflowY: 'scroll',
                    }}>
                    <Loader isLoading={modelGetOportFlyer.loading}>
                      {flyerSubmitAlert.text && (
                        <Alert
                          title={flyerSubmitAlert.title}
                          type={flyerSubmitAlert.type}
                          text={flyerSubmitAlert.text}
                          closable={flyerSubmitAlert.closable}
                        />
                      )}
                      {flyer ? (
                        <>
                          Archivo:{' '}
                          <a href={flyer.url} target="_blank" rel="noreferrer">
                            {flyer.key.split('/').pop()}
                          </a>
                          <br />
                          <br />
                          <div>
                            <div style={{display: 'inline-block'}}>
                              <ButtonWithLoading
                                text="Eliminar"
                                type="warning"
                                size="sm"
                                loading={modelEliminarOportFlyer.loading}
                                submit={() =>
                                  setIsModalEliminarFlyerShown(true)
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        'Sin flyer'
                      )}
                    </Loader>
                  </div>
                </Box>
              </Col>
            )}

            {mode === 'edit' && (
              <Col md="8">
                <Box
                  title="Formulario de relevamiento"
                  customOptions={
                    <ButtonWithLoading
                      text="Ir a agregar"
                      type="default"
                      size="sm"
                      loading={false}
                      submit={() =>
                        setModalRedirect(
                          `/oportunidad/relevamiento/${oportunidadIdNumerico}`,
                        )
                      }
                    />
                  }>
                  <div
                    style={{
                      maxHeight: 200,
                      minHeight: 200,
                      overflowY: 'scroll',
                    }}>
                    <Loader isLoading={modelGetOportRelevamiento.loading}>
                      {relevamientoSubmitAlert.text && (
                        <Alert
                          title={relevamientoSubmitAlert.title}
                          type={relevamientoSubmitAlert.type}
                          text={relevamientoSubmitAlert.text}
                          closable={relevamientoSubmitAlert.closable}
                        />
                      )}
                      {relevamiento ? (
                        <>
                          Archivo:{' '}
                          <a
                            href={relevamiento.url}
                            target="_blank"
                            rel="noreferrer">
                            {relevamiento.key.split('/').pop()}
                          </a>
                          <br />
                          <br />
                          <div>
                            <div style={{display: 'inline-block'}}>
                              <ButtonWithLoading
                                text="Eliminar"
                                type="warning"
                                size="sm"
                                loading={modelEliminarOportRelevamiento.loading}
                                submit={() =>
                                  setIsModalEliminarRelevamientoShown(true)
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        'Sin formulario de relevamiento'
                      )}
                    </Loader>
                  </div>
                </Box>
              </Col>
            )}
          </Col>
        </Row>
        <Row>
          <Col md="10" mdOffset="1">
            <Box title="Publicación">
              <Row>
                <Col md="6">
                  <CampoPublicacion
                    titulo="Descripción principal para la web"
                    mRef={proposRef}
                    publicar={muestraPosicion}
                    setPublicar={setMuestraPosicion}
                    initialValue={proposito}
                  />
                </Col>
                <Col md="6">
                  <CampoPublicacion
                    titulo="Funciones"
                    mRef={responRef}
                    publicar={muestraResponsabilidad}
                    setPublicar={setMuestraResponsabilidad}
                    initialValue={responsabilidad}
                  />
                </Col>
                <Col md="6">
                  <CampoPublicacion
                    titulo="Conocimientos específicos"
                    mRef={conEspRef}
                    publicar={muestraConocimientoEspecifico}
                    setPublicar={setMuestraConocimientoEspecifico}
                    initialValue={conocimientoEspecifico}
                  />
                </Col>
                <Col md="6">
                  <CampoPublicacion
                    titulo="Formación académica"
                    mRef={conDesRef}
                    publicar={muestraConocimientoDeseable}
                    setPublicar={setMuestraConocimientoDeseable}
                    initialValue={conocimientoDeseable}
                  />
                </Col>
                <Col md="6">
                  <CampoPublicacion
                    titulo="Experiencia requerida"
                    mRef={expReqRef}
                    publicar={muestraExperienciaRequerida}
                    setPublicar={setMuestraExperienciaRequerida}
                    initialValue={experienciaRequerida}
                  />
                </Col>
                {/* <CampoPublicacion
                titulo="Aptitudes"
                mRef={aptitudesRef}
                publicar={muestraAptitud}
                setPublicar={setMuestraAptitud}
                initialValue={aptitud}
              /> */}
                <Col md="6">
                  <CampoPublicacion
                    titulo="Requisitos adicionales"
                    mRef={reqAdRef}
                    publicar={muestraRequisitoAdicional}
                    setPublicar={setMuestraRequisitoAdicional}
                    initialValue={requisitoAdicional}
                  />
                </Col>
              </Row>

              {submitAlert.text && (
                <Alert
                  title={submitAlert.title}
                  type={submitAlert.type}
                  text={submitAlert.text}
                  closable={submitAlert.closable}
                />
              )}

              <ButtonWithLoading
                text="Guardar"
                submit={submit}
                pullRight
                loading={modelCrearOportunidad.loading}
                disabled={modelCrearOportunidad.loading || creado}
              />
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
}

export {CrearOportunidadView};
